import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import "../../styles/Blog.css";
import NotFound from "../NotFound";
import strings from "../../blog/strings";
import useBlogHead from "../../blog/seo";
import { collectionPageLd, breadcrumbLd } from "../../blog/schema";
import { getTag, getPostsBySlugs, langConfig, absolute } from "../../blog/data";
import { Breadcrumbs, PostCard } from "./parts";

function BlogTag({ lang }) {
  const { tag: tagSlug } = useParams();
  const tag = getTag(lang, tagSlug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tagSlug]);

  if (!tag) return <NotFound />;

  const t = strings(lang);
  const cfg = langConfig(lang);
  const posts = getPostsBySlugs(lang, tag.posts);
  const title = `${t.tagTitle(tag.tag)} | ${cfg.title}`;
  const description = t.tagIntro(tag.tag, tag.count);
  const crumbs = [
    { name: t.home, path: "/" },
    { name: cfg.title, path: cfg.indexPath },
    { name: t.tagTitle(tag.tag) },
  ];

  return (
    <div className="blog">
      <BlogTagHead
        lang={lang}
        cfg={cfg}
        tag={tag}
        title={title}
        description={description}
        posts={posts}
        crumbs={crumbs}
      />

      <div className="blog-shell">
        <Breadcrumbs lang={lang} items={crumbs} />
        <header className="blog-index-header">
          <h1>{t.tagTitle(tag.tag)}</h1>
          <p className="blog-lead">{description}</p>
        </header>
        <div className="blog-list">
          {posts.length === 0 ? (
            <p>{t.emptyTag}</p>
          ) : (
            posts.map((post) => <PostCard key={post.slug} lang={lang} post={post} />)
          )}
        </div>
      </div>
    </div>
  );
}

function BlogTagHead({ lang, cfg, tag, title, description, posts, crumbs }) {
  // Cienkie strony tagów (poniżej progu z blog.config.js) nie mają wartości dla
  // wyszukiwarki — noindex, follow: linki dalej przekazują sygnał, strona nie
  // trafia do indeksu ani do sitemap.
  useBlogHead({
    title,
    description,
    canonical: tag.url,
    lang,
    locale: cfg.locale,
    ogType: "website",
    robots: tag.indexable ? undefined : "noindex, follow",
    jsonLd: [
      collectionPageLd({
        url: tag.url,
        name: title,
        description,
        lang,
        posts,
      }),
      breadcrumbLd(
        crumbs.map((c) => ({ name: c.name, url: c.path ? absolute(c.path) : tag.url }))
      ),
    ],
  });
  return null;
}

export default BlogTag;
